module.exports = __webpack_public_path__ + "img/icon-meat-grey.6cbe6e53.svg";